import { AccordionItem, Content, ImageContainer, LinkInline, Section, VisuallyHidden } from './styles';
import React, { useState } from 'react';

import Arrow from '@/components/ui/icons/Arrow';
import Image from 'next/image';
import Link from 'next/link';
import Plus from '@/components/ui/icons/Plus';

type Service = {
  key: number;
  title: string;
  content: string;
  link?: string;
};

interface CollapsibleProps {
  titleText: string;
  contentText?: string;
  servicesList: Service[];
  image?: string;
  imageAlt?: string;
}

const CollapsibleText: React.FC<CollapsibleProps> = ({
  titleText,
  contentText,
  servicesList,
  image,
  imageAlt = '',
}) => {
  const [toggleValue, setToggleValue] = useState(-1);

  const toggleHandler = (index) => {
    setToggleValue(toggleValue === index ? -1 : index);
  };

  return (
    <Section expanded={toggleValue !== -1}>
      <Content>
        <h2>{titleText}</h2>
        <p>{contentText}</p>
        {servicesList.map((item, index) => (
          <AccordionItem
            key={index}
            onClick={() => toggleHandler(index)}
            expanded={toggleValue === index}
            role="button"
            tabIndex={0}
            aria-expanded={toggleValue === index}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleHandler(index);
              }
            }}
          >
            <h3>
              {item.title}
              <Plus className="action-icon" />
            </h3>
            <div className="accordion-item-content">
              <span>{item.content}</span>
              {item.link ? (
                <Link href={item.link}>
                  <LinkInline>
                    Learn More
                    <VisuallyHidden>{` about ${item.title}`}</VisuallyHidden>
                    <Arrow style={{ marginLeft: '6px' }} />
                  </LinkInline>
                </Link>
              ) : (
                <span style={{ margin: '2em 0' }} />
              )}
            </div>
          </AccordionItem>
        ))}
      </Content>
      <ImageContainer>
        {image && <Image src={image} alt={imageAlt} fill sizes="(min-width: 768px) 47vw, 100vw" />}
      </ImageContainer>
    </Section>
  );
};

export default CollapsibleText;
